import { render, staticRenderFns } from "./home_xs.vue?vue&type=template&id=3a3f8641"
import script from "./home_xs.vue?vue&type=script&lang=js"
export * from "./home_xs.vue?vue&type=script&lang=js"
import style0 from "./home_xs.vue?vue&type=style&index=0&id=3a3f8641&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports